import React, { useState } from 'react';
import { X, Shield, Lock, Eye, UserCheck, ChevronDown } from 'lucide-react';
import './Modal.css';

const PrivacyModal = ({ isOpen, onClose, t }) => {
  const [openSection, setOpenSection] = useState(null);

  if (!isOpen) return null;

  const sections = [
    {
      icon: <UserCheck size={24} />,
      title: t.privacy.section1Title,
      content: <p style={{ whiteSpace: 'pre-line' }}>{t.privacy.section1Text}</p>
    },
    {
      icon: <Shield size={24} />,
      title: t.privacy.section2Title,
      content: <p style={{ whiteSpace: 'pre-line' }}>{t.privacy.section2Text}</p>
    },
    {
      icon: <Lock size={24} />,
      title: t.privacy.section3Title,
      content: <p style={{ whiteSpace: 'pre-line' }}>{t.privacy.section3Text}</p>
    },
    {
      icon: <Eye size={24} />,
      title: t.privacy.section4Title,
      content: <p style={{ whiteSpace: 'pre-line' }}>{t.privacy.section4Text}</p>
    }
  ];

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={28} />
        </button>
        
        <div className="modal-body">
          <div className="modal-header">
            <Shield size={40} className="modal-header-icon" />
            <h2 className="modal-title">{t.privacy.title}</h2>
          </div>

          <div className="privacy-accordion">
            {sections.map((section, index) => (
              <div key={index} className={`privacy-accordion-item ${openSection === index ? 'open' : ''}`}>
                <button className="privacy-accordion-header" onClick={() => toggleSection(index)}>
                  <div className="privacy-accordion-title-wrapper">
                    <div className="privacy-section-icon">{section.icon}</div>
                    <h3 className="privacy-section-title">{section.title}</h3>
                  </div>
                  <ChevronDown className={`privacy-accordion-icon ${openSection === index ? 'rotated' : ''}`} size={24} />
                </button>
                
                <div className={`privacy-accordion-content ${openSection === index ? 'open' : ''}`}>
                  <div className="privacy-text">
                    {section.content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;